import { useAuthStore } from "@/stores";

export default (to, from, next) => {
  const authStore = useAuthStore();
  if (authStore.isAuthenticated) {
    return next({ name: "dictionary" });
  }

  return next();
};
